import {
  ADMIN_ANALYTICS_DASHBOARD_REQUEST,
  ADMIN_ANALYTICS_DASHBOARD_SUCCESS,
} from '../types'

// Flat status/data/error - the whole Admin Analytics Dashboard now comes
// from one fetch (one stored-procedure call), so there's no per-widget
// metric map to key state by anymore.
const INITIAL_STATE = {
  status: 'idle',
  data: null,
  error: null,
}

const adminAnalyticsReducer = (state = INITIAL_STATE, { type, payload } = {}) => {
  switch (type) {
    case ADMIN_ANALYTICS_DASHBOARD_REQUEST:
      return { ...state, status: 'loading', error: null }
    case ADMIN_ANALYTICS_DASHBOARD_SUCCESS:
      return { ...state, status: 'success', data: payload.data, error: null }
    default:
      return state
  }
}

export default adminAnalyticsReducer
